export const ContractorsListingMutations = {
  SetContractorsLoading: 'ContractorsListingMutations.SetContractorsLoading',
  SetContractorsList: 'ContractorsListingMutations.SetContractorsList',
  SetContractorsSortOrder: 'ContractorsListingMutations.SetContractorsSortOrder',
  SetContractorsPaginationParameters:
    'ContractorsListingMutations.SetContractorsPaginationParameters',
  ResetContractorsPaginationOffset: 'ContractorsListingMutations.ResetContractorsPaginationOffset',
  SetContractorsRecordCount: 'ContractorsListingMutations.SetContractorsFilteredRecordCount',
  SetContractorsActiveInactive: 'ContractorsListingMutations.SetContractorsActiveInactive',
  SetContractorsSearchParam: 'ContractorsListingMutations.SetContractorsSearchParam'
};

export const ContractorsListingActions = {
  RetrieveContractors: 'ContractorsListingActions.RetrieveContractors',
  SetContractorsSortOrder: 'ContractorsListingActions.SetContractorsSortOrder',
  SelectContractor: 'ContractorsListingActions.SelectContractor',
  SetContractorsPaginationParameters:
    'ContractorsListingActions.SetContractorsPaginationParameters',
  RetrieveContractorsRecordCount: 'ContractorsListingActions.RetrieveContractorsRecordCount',
  ExportContractorsAsExcel: 'ContractorsListingActions.ExportContractorsAsExcel',
  SetContractorsActiveInactive: 'ContractorsListingActions.SetContractorsActiveInactive',
  UpdateContractorsList: 'ContractorsListingActions.UpdateContractorsList',
  SetContractorsSearchParam: 'ContractorsListingActions.SetContractorsSearchParam',
  UpdatePermPlacements: 'PermPlacementsListingActions.UpdatePermPlacements'
};

export const ContractorsListingGetters = {
  ContractorsList: 'ContractorsListingGetters.ContractorsList',
  SortBy: 'ContractorsListingGetters.SortBy',
  SortDirection: 'ContractorsListingGetters.SortDirection',
  ContractorsPerPage: 'ContractorsListingGetters.ContractorsPerPage',
  ContractorsListingOffset: 'ContractorsListingGetters.ContractorsListingOffset',
  ContractorsRecordCount: 'ContractorsListingGetters.ContractorsRecordCount',
  ContractorsActiveInactive: 'ContractorsListingGetters.ContractorsActiveInactive',
  UpdateContractorsList: 'ContractorsListingGetters.UpdateContractorsList'
};
